export const sanitizeId = (id: string): string => id.trim().replace('/', '-')
